export default __webpack_public_path__ + "static/media/meslay15.38d28de2.jpg";